module.exports = __webpack_public_path__ + "img/gas-analysis.a1893e91.svg";